import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoHierarchicalDataSourceMixin from './KendoHierarchicalDataSourceMixin'

export default {
    name: 'kendo-hierarchicaldatasource',
    mixins: [ KendoHierarchicalDataSourceMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoHierarchicalDataSource/index.js